export default __webpack_public_path__ + "static/media/Ashish.cdadc747.jpg";